import React, { useEffect, useState } from 'react';
import { localize } from 'src/l10n';
import { SocialPostSharePost } from 'src/social-feed/components/SocialPostShare/SocialPostShare';
import { getSharePreviewAsync } from 'src/share';

interface IProps {
    uberId: number;
}

type SharePreview = Spintr.ISocialPostBase | null;

// cached so remounts in the virtualized list don't refetch and jump
const previewRequests = new Map<number, Promise<SharePreview>>();
const loadedPreviews = new Map<number, SharePreview>();

function loadSharePreview(uberId: number): Promise<SharePreview> {
    let request = previewRequests.get(uberId);

    if (!request) {
        request = getSharePreviewAsync(uberId)
            .then((data) => {
                loadedPreviews.set(uberId, data);
                return data;
            })
            .catch((error) => {
                // retry on next mount
                previewRequests.delete(uberId);
                throw error;
            });

        previewRequests.set(uberId, request);
    }

    return request;
}

const ChatSharePreview = (props: IProps) => {
    const [share, setShare] = useState<SharePreview>(() => loadedPreviews.get(props.uberId) ?? null);
    const [hasError, setHasError] = useState<boolean>(false);

    useEffect(() => {
        let cancelled = false;

        setHasError(false);

        if (loadedPreviews.has(props.uberId)) {
            setShare(loadedPreviews.get(props.uberId));
            return;
        }

        setShare(null);

        loadSharePreview(props.uberId)
            .then((data) => {
                if (!cancelled) {
                    setShare(data);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setHasError(true);
                }
            });

        return () => { cancelled = true; };
    }, [props.uberId]);

    if (hasError) {
        return <div className="chat-share-preview-error">{localize("TeknisktFel")}</div>;
    }

    if (!share) {
        return null;
    }

    return <SocialPostSharePost post={{ Share: share } as any} />;
};

export default ChatSharePreview;
